import type { KpiTile } from '../../lib/aggregate'

interface KpiTilesProps {
  tiles: KpiTile[]
}

export function KpiTiles({ tiles }: KpiTilesProps) {
  return (
    <div className="grid grid-cols-2 gap-2.5">
      {tiles.map(([value, label]) => (
        <div key={label} className="rounded-[14px] border border-slate-900/10 bg-white p-3">
          <div className="truncate text-lg font-extrabold">{value}</div>
          <div className="text-muted-text mt-0.5 text-[10px] tracking-wide uppercase">{label}</div>
        </div>
      ))}
    </div>
  )
}
